interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullPage?: boolean;
}

const sizeClasses = {
  sm: 'loading-spinner-sm',
  md: '',
  lg: 'loading-spinner-lg',
};

export function LoadingSpinner({ size = 'md', text, fullPage = false }: LoadingSpinnerProps) {
  const spinner = (
    <div className="loading-container">
      <div className={`loading-spinner ${sizeClasses[size]}`} />
      {text && <span className="loading-text">{text}</span>}
    </div>
  );

  if (fullPage) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        {spinner}
      </div>
    );
  }

  return spinner;
}
